import { LiliButton } from '@lili/lili-frontend-common';
import { useBoundStore } from '@Store/index.ts';

export const StoreSnapShot = () => {
  const isLocalHost = window.location.hostname.includes('localhost');
  const takeSnapshot = () => {
    const state = useBoundStore.getState();
    const stateString = JSON.stringify(state);
    const blob = new Blob([stateString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'store-snapshot.json';
    a.click();
  };
  return isLocalHost ? (
    <LiliButton
      className='absolute w-fit z-[9999] bg-text-badge-green left-[8px] bottom-[8px]'
      id=''
      title='Snapshot'
      onClick={takeSnapshot}
    />
  ) : null;
};
